RivalIQ.apps.Admin.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.ImpersonateAction = Marionette.Behavior.extend({
        ui: {
            impersonateBtn: '.btn-impersonate'
        },

        events: {
            'click @ui.impersonateBtn': 'impersonateUser'
        },

        onShow: function () {
            const me = this;

            if (me.view.getAccountStatus() === RivalIQ.enums.account.status.REGISTRATION ||
                me.view.getAccountUserStatus() === RivalIQ.enums.user.status.invited.id) {
                me.ui.impersonateBtn.attr('disabled', true);
            }
        },

        impersonateUser: function (e) {
            const me = this;
            e.preventDefault();

            me.ui.impersonateBtn.button('loading');
            $.ajax({
                type: 'POST',
                url: me.getImpersonationUrl(me.view.getImpersonationEmail()),
                data: null,
                error: function (data) {
                    me.ui.impersonateBtn.button('reset');
                    RivalIQ.execute('alert:error', data);
                },
                success: function (data) {
                    window.location = data.location;
                }
            });
        },

        getImpersonationUrl: function (email) {
            return `/admin/impersonate?email=${encodeURIComponent(email)}`;
        }
    });

});
